// extracted by mini-css-extract-plugin
export default {"toc":"r_bD","h3toc":"r_bF","linkText":"r_bG","tocTitle":"r_bH"};